import { TemplateElement, html, defineElement, i18n } from '@webtides/element-js';

import { ComparisonService, ComparisonServiceEvents } from './ComparsionService';
export default class ComparisonDelete extends TemplateElement {
    properties() {
        return {
            sku: false,
            isInComparsion: false,
            reload: true,
        };
    }

    async connected() {
        this.isInComparsion = await ComparisonService.has(this.sku);
    }

    events() {
        return {
            document: {
                [ComparisonServiceEvents.UPDATE]: async () => {
                    this.isInComparsion = await ComparisonService.has(this.sku);
                },
            },
            button: {
                click: async () => {
                    await ComparisonService.remove(this.sku);
                    if (this.reload) {
                        location.search = '';
                    }
                    // location.reload();
                },
            },
        };
    }

    template() {
        if (!this.isInComparsion) {
            return;
        }
        return html`<button class="flex items-center">
            <svg-icon class="inline-block w-4 h-4 mr-1" name="close"></svg-icon>
        </button>`;
    }
}

defineElement('comparison-delete', ComparisonDelete);
